export const APP_NAME = 'Go Web Portal';

export const ANALYTICS_CONSTANTS = {
  event: {
    logIn: 'Login Success',
    logOut: 'User Logout - Web',
    incorrectPassword: 'Incorrect Password',
    visitAdd: 'Visit Added - Web',
    visitDelete: 'Visit Deleted - Web',
    visitSelect: 'Visit Selected - Web',
    datePickerSelect: 'Date Picker Selected - Web',
    noteCopy: 'Note Copied - Web',
    noteEdit: 'Note Edit - Web',
    recordingStart: 'Recording Started - Web',
    recordingStop: 'Recording Stopped - Web',
    visitArchived: 'Visit Archived - Web',
    noteUploaded: 'Note Uploaded - Web',
    noteUploadFailed: 'Note Upload Failed - Web',
    loginUserName: 'Username Entered In Login Flow',
    loginSSORedirect: 'Redirecting To SSO Login Page',
    loginSSOReturn: 'Returning To Augmedix After SSO Redirect',
    createPin: 'Create Pin',
    verifyPin: 'Verify PIN Creation',
    enteredValidPin: 'Entered valid pincode',
    enteredInvalidPin: 'Entered invalid pincode',
    tappedNotYou: 'Tapped on NOT YOU button',
    addNewTemplate: 'Add New Template',
    saveTemplate: 'Save Template',
    updateTemplate: 'Update Template',
    deleteTemplate: 'Delete Template',
    deleteTemplateConfirm: 'Delete Template - Confirm',
    clearTemplate: 'Clear Template',
    clearTemplateConfirm: 'Clear Template - Confirm',
    tappedResetPIN: 'Tapped on RESET PIN',
    resetPIN: 'Reset Pin',
    preferencesViewed: 'Preferences Viewed',
    preferencesSaved: 'Preferences Saved',
    infoModalOpened: 'Info Modal Opened',
    infoModalClosed: 'Info Modal Closed',
    careCuesAddToNoteButtonTapped: 'CareCues Add to Note Button Tapped',
    careCuesArchived: 'CareCues Archived',
    navigatedToCareCuesFromCareCuesUploadModal: 'Navigated to CareCues from Upload CareCues Modal',
    uploadedNoteFromCareCuesUploadModal: 'Uploaded the note from Upload CareCues Modal',
    uploadCareCuesModalTriggered: 'Upload CareCues Modal Triggered',
    careCuesSeen: 'CareCues Seen',
    verbalizationEducationModal: 'Verbalization Education Modal',
    noteLevelThumbsUp: 'Note-Level Feedback Thumbs Up Selected',
    noteLevelThumbsDown: 'Note-Level Feedback Thumbs Down Selected',
    noteLevelFeedbackReason: 'Note-Level Feedback Reason Selected',
    noteLevelFeedbackTextSubmitted: 'Note-Level Feedback Open Text Submitted',
    noteLevelFeedbackModalOpened: 'Note-Level Feedback Modal Opened',
    noteLevelFeedbackModalClosed: 'Note-Level Feedback Modal Closed',
    noteLevelFeedbackReasonAdded: 'Note-Level Feedback Reason Added',
    noteLevelFeedbackReasonRemoved: 'Note-Level Feedback Reason Removed',
    labInterpretationsViewed: 'Lab interpretations viewed',
    interpretationRejected: 'Interpretation Rejected',
    interpretationAccepted: 'Interpretation Accepted',
    interpretationEdited: 'Interpretation Edited',
    addReEvaluationModalOpened: 'Add Re-Evaluation Modal Opened',
    addReEvaluationModalClosed: 'Add Re-Evaluation Modal Closed',
    icd10CodeSelected: 'ICD-10 Code Selected',
    icd10CodeUpdated: 'ICD-10 Code Updated',
    icd10DropdownExpanded: 'ICD-10 dropdown expanded',
  },
  properties: {
    visitDateTime: 'Visit Date/Time',
    eventDateTime: 'Event Date/Time',
    dateSelected: 'Date Selected',
    noteId: 'Note ID',
    noteSection: 'Note Section',
    icd10Code: 'ICD-10 Code',
    wordsAddedCount: 'Words Added',
    wordsRemovedCount: 'Words Removed',
    providerGuid: 'Clinician GUID',
    providerUid: 'Clinician UID',
    providerName: 'Clinician Name',
    providerEmail: 'Clinician Email',
    ipAddress: 'IP Address',
    browserName: 'Browser Name',
    browserVersion: 'Browser Version',
    os: 'OS',
    osVersion: 'OS Version',
    action: 'Action',
    preferenceType: 'Preference Type',
    uploadMethod: 'Upload Method',
    packageAssigned: 'Package Assigned',
    errorMessage: 'Error Message',
    appName: 'App Name',
    redirectUrl: 'Redirect URL',
    method: 'Method',
    enterprise: 'Enterprise',
    ehr: 'EHR',
    specialty: 'Specialty',
    copyMethod: 'Method',
    copiedWordsCount: 'Words Count',
    templateName: 'Template Name',
    userConfirmation: 'User Confirmation',
    deviceId: 'Device ID',
    acknowledged: 'Acknowledged',
    reason: 'Reason',
    textLength: 'Text Length',
    feedbackProvided: 'Feedback Provided',
  },

  uploadMethods: {
    mdsUploadOnly: 'MDS Upload Only',
    mdsEditAndUpload: 'MDS Edit + Upload',
    uploadToEhr: 'Upload to EHR',
  },
  loginMethods: {
    password: 'Password',
    sso: 'SSO',
    passcode: 'PIN',
  },
  copyMethods: {
    button: 'Copy Button',
    selection: 'User Selection',
  },
};

export interface AnalyticsProperties {
  visitDateTime?: string;
  eventDateTime?: string;
  noteId?: string;
  providerGuid?: string;
  providerUid?: string;
  providerName?: string;
  providerEmail?: string;
  ipAddress?: string;
  browserName?: string;
  browserVersion?: string;
  os?: string;
  osVersion?: string;
  action?: string;
  noteSection?: string;
  uploadMethod?: string;
  packageAssigned?: string;
  errorMessage?: string;
  redirectUrl?: string;
  method?: string;
  enterprise?: string;
  ehr?: string;
  specialty?: string;
  templateName?: string;
  preferenceType?: string;
  userConfirmation?: string;
  acknowledged?: string;
  reason?: string;
  textLength?: string;
  feedbackProvided?: boolean;
}

export interface AnalyticsActions {
  onVisitAddition: (properties: AnalyticsProperties) => void;
  onVisitDeletion: (properties: AnalyticsProperties) => void;
  onVisitSelection: (properties: AnalyticsProperties) => void;
  onDatePickerSelection: (properties: DatePickerSelectionProps) => void;
  onRecordingStart: (properties: AnalyticsProperties) => void;
  onRecordingStop: (properties: AnalyticsProperties) => void;
  onNoteCopied: (properties: NoteCopyProps) => void;
  onNoteEdit: (properties: NoteSentenceProps) => void;
  onUserLogout: (properties?: AnalyticsProperties) => void;
  onVisitArchived: (properties: AnalyticsProperties) => void;
  onNoteUploaded: (properties: AnalyticsProperties) => void;
  onNoteUploadFailed: (properties: AnalyticsProperties) => void;
  onUserLogin: (properties?: AnalyticsProperties) => void;
  onUserLoginFailedPWD: (properties?: AnalyticsProperties) => void;
  onUsernameInput: (properties: AnalyticsProperties) => void;
  onSSORedirect: (properties: AnalyticsProperties) => void;
  onSSOReturn: (properties: AnalyticsProperties) => void;
  onCreatePin: (properties: AnalyticsProperties) => void;
  onVerifyPin: (properties: AnalyticsProperties) => void;
  onTapNotYou: (properties: AnalyticsProperties) => void;
  onEnteredValidPin: (properties: AnalyticsProperties) => void;
  onEnteredInvalidPin: (properties: AnalyticsProperties) => void;
  onAddNewTemplate: (properties: AnalyticsProperties) => void;
  onSaveTemplate: (properties: AnalyticsProperties) => void;
  onUpdateTemplate: (properties: AnalyticsProperties) => void;
  onDeleteTemplate: (properties: AnalyticsProperties) => void;
  onDeleteTemplateConfirm: (properties: AnalyticsProperties) => void;
  onClearTemplate: (properties: AnalyticsProperties) => void;
  onClearTemplateConfirm: (properties: AnalyticsProperties) => void;
  onTapResetPIN: (properties?: AnalyticsProperties) => void;
  onResetPIN: (properties?: AnalyticsProperties) => void;
  onPreferencesViewed: () => void;
  onPreferencesSaved: (properties: AnalyticsProperties) => void;
  onCareCuesAddToNoteButtonTapped: (properties: { noteId: string }) => void;
  onCareCuesArchived: (properties: AnalyticsProperties) => void;
  onCareCuesSeen: (properties: AnalyticsProperties) => void;
  onNavigatedToCareCuesFromCareCuesUploadModal: (properties: { noteId: string }) => void;
  onUploadedNoteFromCareCuesUploadModal: (properties: { noteId: string }) => void;
  onUploadCareCuesModalTriggered: (properties: { noteId: string }) => void;
  onInfoModalOpened: (properties: AnalyticsProperties) => void;
  onInfoModalClosed: (properties: AnalyticsProperties) => void;
  onVerbalizationEducationModal: (properties: AnalyticsProperties) => void;
  onNoteLevelThumbsUp: (properties: AnalyticsProperties) => void;
  onNoteLevelThumbsDown: (properties: AnalyticsProperties) => void;
  onNoteLevelFeedbackReason: (properties: AnalyticsProperties) => void;
  onNoteLevelFeedbackTextSubmitted: (properties: AnalyticsProperties) => void;
  onNoteLevelFeedbackModalOpened: (properties: AnalyticsProperties) => void;
  onNoteLevelFeedbackModalClosed: (properties: AnalyticsProperties) => void;
  onNoteLevelFeedbackReasonAdded: (properties: AnalyticsProperties) => void;
  onNoteLevelFeedbackReasonRemoved: (properties: AnalyticsProperties) => void;
  onLabInterpretationsViewed: (properties: AnalyticsProperties) => void;
  onInterpretationRejected: (properties: AnalyticsProperties) => void;
  onInterpretationAccepted: (properties: AnalyticsProperties) => void;
  onInterpretationEdited: (properties: AnalyticsProperties) => void;
}

export interface DatePickerSelectionProps extends AnalyticsProperties {
  selectedDate: string;
}

export interface NoteSectionProps extends AnalyticsProperties {
  noteSection: string;
}

export interface NoteSentenceProps extends AnalyticsProperties {
  eventDateTime: string;
  noteSection: string;
  wordsAdded: number;
  wordsRemoved: number;
}

export interface NoteCopyProps extends NoteSectionProps {
  method: string;
  wordsCount?: number;
}

export interface DispatchedEvent {
  eventName: string;
  properties: AnalyticsProperties;
}
